import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { DocumentDirectionProvider, Toaster, useDocumentLanguage } from '@klareospace/pharos-lib-web-utils';
import type { PermissionsContextValue } from '@klareospace/pharos-lib-front-utils';
import type { AuthContextValue } from '&/auth';

export interface RouterContext {
  auth: AuthContextValue;
  permissions: PermissionsContextValue;
}

function RootLayout(): React.JSX.Element {
  useDocumentLanguage();
  return (
    <DocumentDirectionProvider>
      <Outlet />
      <Toaster />
    </DocumentDirectionProvider>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});
